import { Box, Card, Chip, Dialog, Stack } from '@mui/material';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  useTranslate,
  DeleteButton,
  SelectInput,
  NumberField,
  TextInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import CreateBanner from './Create';
import EditBanner from './Edit';
import './init';
import FilterGroup from '../../components/FilterGroup';

const ListFilter = (props: any) => (
  <Filter {...(props || {})}>
    <FilterGroup alwaysOn spacing={2} p={2}>
      <SelectInput
        source="platform"
        label="module.banners.platform"
        choices={[
          { id: 'ALL', name: 'ALL' },
          { id: 'PC', name: 'PC' },
          { id: 'APP', name: 'APP' },
          { id: 'H5', name: 'H5' },
        ]}
      />
      <TextInput source="category" label="module.banners.category" />
    </FilterGroup>
  </Filter>
);

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();
  const formatWithToISOString = (date: Date) => {
    // 步骤1：修正时区（东八区）
    const offset = date.getTimezoneOffset() * 60000; // 东八区为-480分钟 → -28800000毫秒
    const localDate = new Date(date.getTime() - offset);

    // 步骤2：调用toISOString() + 去掉Z后缀 + 裁剪毫秒
    const isoStr = localDate.toISOString(); // 此时是东八区的ISO串：2025-12-18T16:14:00.000Z
    const formatted = isoStr.replace('.000Z', ''); // 去掉毫秒和Z → 2025-12-18T16:14:00

    return formatted;
  };
  return (
    <PermissionGuard resource="banners" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.banners')}
          links={[
            { name: translate('resource.banners'), href: `/${Resources.banners}` },
            { name: translate('resource.list') },
          ]}
          action={
            <PermissionGuard resource="banners" action="create" fallback={<></>}>
              <CreateButton
                variant="contained"
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  setPopup(<CreateBanner onClose={() => setPopup(undefined)} />);
                }}
              />
            </PermissionGuard>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            filters={<ListFilter />}
            perPage={10}
            exporter={false}
            resource={Resources.banners}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                // bulkActionButtons={
                //   <PermissionButton resource="banners" action="delete">
                //     <BulkDeleteButton />
                //   </PermissionButton>
                // }
                sx={{
                  '& .RaDatagrid-table': {
                    tableLayout: 'fixed',
                    minWidth: 1800,
                    width: '100%',
                  },
                  '& .RaDatagrid-thead th, & .RaDatagrid-tbody td': {
                    whiteSpace: 'nowrap',
                    padding: '8px 12px',
                    verticalAlign: 'middle',
                  },
                  /* 勾选框 */
                  '& .RaDatagrid-thead th:nth-of-type(1), & .RaDatagrid-tbody td:nth-of-type(1)': {
                    width: 80,
                    minWidth: 80,
                  },
                  /* SortIndex */
                  '& .RaDatagrid-thead th:nth-of-type(2), & .RaDatagrid-tbody td:nth-of-type(2)': {
                    width: 80,
                    minWidth: 80,
                  },
                  /* category */
                  '& .RaDatagrid-thead th:nth-of-type(3), & .RaDatagrid-tbody td:nth-of-type(3)': {
                    width: 120,
                    minWidth: 120,
                  },
                  /* platform */
                  '& .RaDatagrid-thead th:nth-of-type(4), & .RaDatagrid-tbody td:nth-of-type(4)': {
                    width: 80,
                    minWidth: 80,
                  },
                  /* route */
                  '& .RaDatagrid-thead th:nth-of-type(5), & .RaDatagrid-tbody td:nth-of-type(5)': {
                    width: 280,
                    minWidth: 280,
                    whiteSpace: 'normal',
                    wordBreak: 'break-all',
                  },
                  /* isInternalRoute */
                  '& .RaDatagrid-thead th:nth-of-type(6), & .RaDatagrid-tbody td:nth-of-type(6)': {
                    width: 110,
                    minWidth: 110,
                  },
                  /* images */
                  '& .RaDatagrid-thead th:nth-of-type(7), & .RaDatagrid-tbody td:nth-of-type(7)': {
                    width: 200,
                    minWidth: 200,
                  },
                  /* title */
                  '& .RaDatagrid-thead th:nth-of-type(8), & .RaDatagrid-tbody td:nth-of-type(8)': {
                    width: 200,
                    minWidth: 200,
                    whiteSpace: 'normal',
                    wordBreak: 'break-all',
                  },
                  /* description */
                  '& .RaDatagrid-thead th:nth-of-type(9), & .RaDatagrid-tbody td:nth-of-type(9)': {
                    width: 200,
                    minWidth: 200,
                    whiteSpace: 'normal',
                    wordBreak: 'break-all',
                  },
                  /* button text */
                  '& .RaDatagrid-thead th:nth-of-type(10), & .RaDatagrid-tbody td:nth-of-type(10)':
                    {
                      width: 160,
                      minWidth: 160,
                      whiteSpace: 'normal',
                      wordBreak: 'break-all',
                    },
                  /* showButton */
                  '& .RaDatagrid-thead th:nth-of-type(11), & .RaDatagrid-tbody td:nth-of-type(11)':
                    {
                      width: 100,
                      minWidth: 100,
                    },
                  /* startAt / endAt */
                  '& .RaDatagrid-thead th:nth-of-type(12), & .RaDatagrid-tbody td:nth-of-type(12)':
                    {
                      width: 180,
                      minWidth: 180,
                      whiteSpace: 'normal',
                    },
                  /* clickOut */
                  '& .RaDatagrid-thead th:nth-of-type(13), & .RaDatagrid-tbody td:nth-of-type(13)':
                    {
                      width: 100,
                      minWidth: 100,
                    },
                  /* IsActive */
                  '& .RaDatagrid-thead th:nth-of-type(14), & .RaDatagrid-tbody td:nth-of-type(14)':
                    {
                      width: 80,
                      minWidth: 80,
                    },
                  /* Edit */
                  '& .RaDatagrid-thead th:nth-of-type(15), & .RaDatagrid-tbody td:nth-of-type(15)':
                    {
                      width: 100,
                      minWidth: 100,
                    },
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                {/*<TextField source="id" label="module.banners.id" sortable={false} />*/}
                <NumberField source="sortIndex" label="module.banners.sortIndex" sortable={false} />

                <TextField source="category" label="module.banners.category" sortable={false} />
                <TextField source="platform" label="module.banners.platform" sortable={false} />
                <FunctionField
                  label="module.banners.route"
                  sortable={false}
                  render={(record: any) => (
                    <Box
                      sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                      }}
                    >
                      {record?.route}
                    </Box>
                  )}
                />
                <FunctionField
                  label="module.banners.isInternalRoute"
                  render={(record: any) => (
                    <Chip
                      label={
                        record.isInternalRoute === true || record.isInternalRoute === 1 ? 'Y' : 'N'
                      }
                      color={
                        record.isInternalRoute === true || record.isInternalRoute === 1
                          ? 'success'
                          : 'default'
                      }
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <FunctionField
                  label="module.banners.imageUrl"
                  sortable={false}
                  render={(record: any) => (
                    <Stack spacing={1}>
                      {record.enImageUrl && (
                        <Box
                          component="img"
                          src={record.enImageUrl}
                          alt="EN"
                          sx={{ maxWidth: 100, maxHeight: 50, objectFit: 'contain' }}
                        />
                      )}
                      {record.zhImageUrl && (
                        <Box
                          component="img"
                          src={record.zhImageUrl}
                          alt="ZH"
                          sx={{ maxWidth: 100, maxHeight: 50, objectFit: 'contain' }}
                        />
                      )}
                    </Stack>
                  )}
                />
                <FunctionField
                  label="module.banners.title"
                  sortable={false}
                  render={(record: any) => (
                    <Stack spacing={0.5}>
                      {record.enTitle && (
                        <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                          {record.enTitle}
                        </Box>
                      )}
                      {record.zhTitle && (
                        <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                          {record.zhTitle}
                        </Box>
                      )}
                    </Stack>
                  )}
                />
                <FunctionField
                  label="module.banners.description"
                  sortable={false}
                  render={(record: any) => (
                    <Stack spacing={0.5}>
                      {record.enDescription && (
                        <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                          {record.enDescription}
                        </Box>
                      )}
                      {record.zhDescription && (
                        <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                          {record.zhDescription}
                        </Box>
                      )}
                    </Stack>
                  )}
                />
                <FunctionField
                  label="module.banners.buttonText"
                  sortable={false}
                  render={(record: any) => (
                    <Stack spacing={0.5}>
                      {record.enButtonText && (
                        <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                          {record.enButtonText}
                        </Box>
                      )}
                      {record.zhButtonText && (
                        <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                          {record.zhButtonText}
                        </Box>
                      )}
                    </Stack>
                  )}
                />
                <FunctionField
                  label="module.banners.showButton"
                  render={(record: any) => (
                    <Chip
                      label={record.showButton === true || record.showButton === 1 ? 'Y' : 'N'}
                      color={
                        record.showButton === true || record.showButton === 1
                          ? 'success'
                          : 'default'
                      }
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <FunctionField
                  label="module.banners.time"
                  sortable={false}
                  render={(record: any) => {
                    const start = Number(record?.startAt);
                    const end = Number(record?.endAt);
                    return (
                      <Stack spacing={0.5}>
                        {!Number.isNaN(start) && (
                          <Box>{formatWithToISOString(new Date(start))}</Box>
                        )}
                        {!Number.isNaN(end) && (
                          <Box sx={{ color: 'text.secondary' }}>
                            {formatWithToISOString(new Date(end))}
                          </Box>
                        )}
                      </Stack>
                    );
                  }}
                />
                <NumberField
                  source="clickCount"
                  label="module.banners.clickCount"
                  sortable={false}
                />
                <FunctionField
                  label="module.banners.isActive"
                  render={(record: any) => (
                    <Chip
                      label={record.isActive === true ? 'True' : 'False'}
                      color={record.isActive === true ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <FunctionField
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      <PermissionGuard resource="banners" action="update" fallback={<></>}>
                        <EditButton
                          onClick={(e) => {
                            e.preventDefault();
                            setPopup(
                              <EditBanner id={record.id} onClose={() => setPopup(undefined)} />
                            );
                          }}
                        />
                      </PermissionGuard>
                      {/*<PermissionGuard resource="banners" action="delete" fallback={<></>}>*/}
                      {/*  <DeleteButton mutationMode="pessimistic" />*/}
                      {/*</PermissionGuard>*/}
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
